export default __webpack_public_path__ + "static/media/veqtor_puerta.eb64abab.svg";